import type { InvestmentProduct, PublicProductPrice } from './productInvestment';

export type InvestmentRowDisplay = {
  showHours?: boolean | null;
  investmentProduct?: InvestmentProduct | null;
  productPrice?: PublicProductPrice | null;
};

/** Explicit row choices override the phase default; catalog products retain their own projection. */
export function investmentRowShowsHours(
  row: InvestmentRowDisplay,
  defaultShowHours: boolean
): boolean {
  if (row.investmentProduct)
    return (
      row.investmentProduct.display === 'expanded' &&
      row.investmentProduct.showHours &&
      row.investmentProduct.priceMode === 'hours'
    );
  if (row.productPrice) return row.productPrice.showHours;
  return row.showHours ?? defaultShowHours;
}

export function investmentTableShowsHours(
  rows: InvestmentRowDisplay[],
  pricingType: string,
  defaultShowHours: boolean
): boolean {
  return (
    pricingType === 'hourly' &&
    (rows.length
      ? rows.some((row) => investmentRowShowsHours(row, defaultShowHours))
      : defaultShowHours)
  );
}
